module.exports = __webpack_public_path__ + "static/img/product4.aa738e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/white/product4.png
// module id = M2gT
// module chunks = 0